var map = {
	"./404/404": [
		11485,
		9
	],
	"./404/404.js": [
		11485,
		9
	],
	"./a-page-template/a-page-template": [
		53559,
		9,
		6085,
		3136,
		8751,
		3559
	],
	"./a-page-template/a-page-template.js": [
		53559,
		9,
		6085,
		3136,
		8751,
		3559
	],
	"./a-page-template/a-page-template.scss": [
		38751,
		9,
		8751
	],
	"./about/about": [
		76304,
		9,
		570,
		6085,
		3136,
		9081,
		7420,
		6304
	],
	"./about/about.js": [
		76304,
		9,
		570,
		6085,
		3136,
		9081,
		7420,
		6304
	],
	"./about/about.scss": [
		77420,
		9,
		7420
	],
	"./adopters/adopters": [
		85942,
		9,
		6085,
		470,
		5942
	],
	"./adopters/adopters.js": [
		85942,
		9,
		6085,
		470,
		5942
	],
	"./adopters/adopters.scss": [
		30470,
		9,
		470
	],
	"./adoption/adoption": [
		65357,
		9,
		5104,
		6085,
		2933,
		3136,
		8065,
		1994,
		1463,
		13,
		4917,
		932,
		6844,
		9673,
		2151,
		806,
		7475,
		2462,
		3806,
		6361,
		5357
	],
	"./adoption/adoption.js": [
		65357,
		9,
		5104,
		6085,
		2933,
		3136,
		8065,
		1994,
		1463,
		13,
		4917,
		932,
		6844,
		9673,
		2151,
		806,
		7475,
		2462,
		3806,
		6361,
		5357
	],
	"./adoption/adoption.scss": [
		16361,
		9,
		6361
	],
	"./adoption/how-using/how-using": [
		3806,
		9,
		8065,
		1994,
		7475,
		3806
	],
	"./adoption/how-using/how-using.js": [
		3806,
		9,
		8065,
		1994,
		7475,
		3806
	],
	"./adoption/how-using/how-using.scss": [
		47475,
		9,
		7475
	],
	"./ally-logos/ally-logos": [
		6105,
		9,
		5104,
		6085,
		3136,
		9838,
		6105
	],
	"./ally-logos/ally-logos.js": [
		6105,
		9,
		5104,
		6085,
		3136,
		9838,
		6105
	],
	"./ally-logos/ally-logos.scss": [
		49838,
		9,
		9838
	],
	"./blog/article-summary/article-summary": [
		32379,
		9,
		1022,
		2379
	],
	"./blog/article-summary/article-summary.js": [
		32379,
		9,
		1022,
		2379
	],
	"./blog/article-summary/article-summary.scss": [
		32539,
		9,
		2539
	],
	"./blog/article/article": [
		40072,
		9,
		5104,
		6085,
		6524,
		1022,
		633,
		5635,
		7119,
		72
	],
	"./blog/article/article.js": [
		40072,
		9,
		5104,
		6085,
		6524,
		1022,
		633,
		5635,
		7119,
		72
	],
	"./blog/article/article.scss": [
		10633,
		9,
		633
	],
	"./blog/article/use-progress": [
		7119,
		9,
		6524,
		7119
	],
	"./blog/article/use-progress.js": [
		7119,
		9,
		6524,
		7119
	],
	"./blog/blog": [
		82755,
		9,
		5104,
		7913,
		6085,
		2933,
		6524,
		6064,
		3136,
		8065,
		1994,
		1463,
		13,
		4917,
		1022,
		932,
		5263,
		6844,
		9673,
		633,
		2379,
		6120,
		5635,
		3770,
		8838,
		977,
		7119,
		3197,
		72,
		806,
		9156,
		2755
	],
	"./blog/blog-context": [
		85263,
		9,
		6085,
		5263
	],
	"./blog/blog-context.js": [
		85263,
		9,
		6085,
		5263
	],
	"./blog/blog.js": [
		82755,
		9,
		5104,
		7913,
		6085,
		2933,
		6524,
		6064,
		3136,
		8065,
		1994,
		1463,
		13,
		4917,
		1022,
		932,
		5263,
		6844,
		9673,
		633,
		2379,
		6120,
		5635,
		3770,
		8838,
		977,
		7119,
		3197,
		72,
		806,
		9156,
		2755
	],
	"./blog/blog.scss": [
		74765,
		9,
		4765
	],
	"./blog/disqus-form/disqus-form": [
		33531,
		9,
		3531
	],
	"./blog/disqus-form/disqus-form.js": [
		33531,
		9,
		3531
	],
	"./blog/explore-page/explore-page": [
		11206,
		9,
		5104,
		6085,
		6524,
		1022,
		5263,
		2379,
		6120,
		3770,
		8838,
		977,
		3197,
		9156,
		1615,
		2208,
		3095,
		1206
	],
	"./blog/explore-page/explore-page.js": [
		11206,
		9,
		5104,
		6085,
		6524,
		1022,
		5263,
		2379,
		6120,
		3770,
		8838,
		977,
		3197,
		9156,
		1615,
		2208,
		3095,
		1206
	],
	"./blog/explore/by-subject": [
		97639,
		9,
		6085,
		5263,
		7211,
		7639
	],
	"./blog/explore/by-subject.js": [
		97639,
		9,
		6085,
		5263,
		7211,
		7639
	],
	"./blog/explore/by-subject.scss": [
		47211,
		9,
		7211
	],
	"./blog/explore/collections": [
		75064,
		9,
		6085,
		5263,
		1084,
		5064
	],
	"./blog/explore/collections.js": [
		75064,
		9,
		6085,
		5263,
		1084,
		5064
	],
	"./blog/explore/collections.scss": [
		41084,
		9,
		1084
	],
	"./blog/gated-content-dialog/gated-content-dialog": [
		84642,
		9,
		6085,
		2933,
		6064,
		3136,
		8065,
		1994,
		1463,
		13,
		4917,
		932,
		6844,
		806,
		1090,
		4642
	],
	"./blog/gated-content-dialog/gated-content-dialog.js": [
		84642,
		9,
		6085,
		2933,
		6064,
		3136,
		8065,
		1994,
		1463,
		13,
		4917,
		932,
		6844,
		806,
		1090,
		4642
	],
	"./blog/gated-content-dialog/gated-content-dialog.scss": [
		81090,
		9,
		1090
	],
	"./blog/latest-blog-posts/latest-blog-posts": [
		99926,
		9,
		5104,
		7913,
		6085,
		1022,
		5263,
		2379,
		6120,
		3770,
		8838,
		977,
		3197,
		9156,
		1615,
		2888,
		9926
	],
	"./blog/latest-blog-posts/latest-blog-posts.js": [
		99926,
		9,
		5104,
		7913,
		6085,
		1022,
		5263,
		2379,
		6120,
		3770,
		8838,
		977,
		3197,
		9156,
		1615,
		2888,
		9926
	],
	"./blog/latest-blog-posts/latest-blog-posts.scss": [
		52888,
		9,
		2888
	],
	"./blog/more-stories/more-stories": [
		96120,
		9,
		6085,
		1022,
		5263,
		2379,
		6120,
		3770,
		8838,
		1615
	],
	"./blog/more-stories/more-stories.js": [
		96120,
		9,
		6085,
		1022,
		5263,
		2379,
		6120,
		3770,
		8838,
		1615
	],
	"./blog/more-stories/more-stories.scss": [
		78838,
		9,
		8838
	],
	"./blog/pinned-article/pinned-article": [
		13095,
		9,
		6085,
		1022,
		5263,
		2379,
		6120,
		3770,
		2208,
		3095
	],
	"./blog/pinned-article/pinned-article.js": [
		13095,
		9,
		6085,
		1022,
		5263,
		2379,
		6120,
		3770,
		2208,
		3095
	],
	"./blog/pinned-article/pinned-article.scss": [
		62208,
		9,
		2208
	],
	"./blog/search-bar/search-bar": [
		79156,
		9,
		5104,
		6085,
		5263,
		977,
		3197,
		9156
	],
	"./blog/search-bar/search-bar.js": [
		79156,
		9,
		5104,
		6085,
		5263,
		977,
		3197,
		9156
	],
	"./blog/search-bar/search-bar.scss": [
		977,
		9,
		977
	],
	"./blog/search-bar/search-context": [
		53197,
		9,
		6085,
		5263,
		3197
	],
	"./blog/search-bar/search-context.js": [
		53197,
		9,
		6085,
		5263,
		3197
	],
	"./blog/search-results/search-results": [
		31278,
		9,
		7913,
		6085,
		1022,
		5263,
		9673,
		2379,
		8347,
		1278
	],
	"./blog/search-results/search-results.js": [
		31278,
		9,
		7913,
		6085,
		1022,
		5263,
		9673,
		2379,
		8347,
		1278
	],
	"./blog/search-results/search-results.scss": [
		58347,
		9,
		8347
	],
	"./blog/section-header/section-header": [
		13770,
		9,
		6120,
		3770
	],
	"./blog/section-header/section-header.js": [
		13770,
		9,
		6120,
		3770
	],
	"./blog/section-header/section-header.scss": [
		56120,
		9,
		6120
	],
	"./blog/timers": [
		48657,
		9,
		8657
	],
	"./blog/timers.js": [
		48657,
		9,
		8657
	],
	"./bookstore-suppliers/bookstore-suppliers": [
		93329,
		9,
		5104,
		6085,
		3136,
		2571,
		3329
	],
	"./bookstore-suppliers/bookstore-suppliers.js": [
		93329,
		9,
		5104,
		6085,
		3136,
		2571,
		3329
	],
	"./bookstore-suppliers/bookstore-suppliers.scss": [
		12571,
		9,
		2571
	],
	"./campaign/campaign": [
		506,
		9,
		6085,
		3136,
		9030,
		672,
		506
	],
	"./campaign/campaign.js": [
		506,
		9,
		6085,
		3136,
		9030,
		672,
		506
	],
	"./campaign/openstax-tutor/openstax-tutor": [
		672,
		9,
		6085,
		3136,
		9030,
		672
	],
	"./campaign/openstax-tutor/openstax-tutor.js": [
		672,
		9,
		6085,
		3136,
		9030,
		672
	],
	"./campaign/openstax-tutor/openstax-tutor.scss": [
		39030,
		9,
		9030
	],
	"./confirmation/confirmation": [
		95050,
		9,
		6085,
		3136,
		7478,
		4268,
		1001,
		6401,
		4208,
		3931,
		2542,
		2999,
		5050
	],
	"./confirmation/confirmation.js": [
		95050,
		9,
		6085,
		3136,
		7478,
		4268,
		1001,
		6401,
		4208,
		3931,
		2542,
		2999,
		5050
	],
	"./confirmation/confirmation.scss": [
		12542,
		9,
		2542
	],
	"./contact/contact": [
		98343,
		9,
		6085,
		2933,
		1463,
		13,
		4917,
		7434,
		6265,
		2910,
		8343
	],
	"./contact/contact.js": [
		98343,
		9,
		6085,
		2933,
		1463,
		13,
		4917,
		7434,
		6265,
		2910,
		8343
	],
	"./contact/contact.scss": [
		16265,
		9,
		6265
	],
	"./contact/form": [
		12910,
		9,
		2933,
		1463,
		13,
		4917,
		7434,
		2910
	],
	"./contact/form.js": [
		12910,
		9,
		2933,
		1463,
		13,
		4917,
		7434,
		2910
	],
	"./details/common/authors": [
		65570,
		9,
		7913,
		9888
	],
	"./details/common/authors.js": [
		65570,
		9,
		7913,
		9888
	],
	"./details/common/common": [
		66603,
		9,
		5104,
		7913,
		8950,
		510,
		9300,
		8290,
		405,
		9888,
		4491
	],
	"./details/common/common.js": [
		66603,
		9,
		5104,
		7913,
		8950,
		510,
		9300,
		8290,
		405,
		9888,
		4491
	],
	"./details/common/customization-form/customization-form": [
		39708,
		9,
		5104,
		7913,
		8065,
		1994,
		510,
		4841,
		7604,
		51,
		4146,
		5986,
		9708
	],
	"./details/common/customization-form/customization-form.js": [
		39708,
		9,
		5104,
		7913,
		8065,
		1994,
		510,
		4841,
		7604,
		51,
		4146,
		5986,
		9708
	],
	"./details/common/customization-form/customization-form.scss": [
		74146,
		9,
		4146
	],
	"./details/common/customization-form/module-list": [
		95986,
		9,
		5104,
		7913,
		510,
		4841,
		7604,
		51,
		5986
	],
	"./details/common/customization-form/module-list.js": [
		95986,
		9,
		5104,
		7913,
		510,
		4841,
		7604,
		51,
		5986
	],
	"./details/common/customization-form/module-list.scss": [
		60051,
		9,
		51
	],
	"./details/common/errata": [
		20405,
		9,
		8950,
		405
	],
	"./details/common/errata.js": [
		20405,
		9,
		8950,
		405
	],
	"./details/common/featured-resources/featured-resources": [
		54397,
		9,
		5104,
		7913,
		8950,
		6064,
		8065,
		1994,
		510,
		4841,
		7604,
		7434,
		51,
		4146,
		8321,
		5986,
		1557,
		9708,
		7856,
		4581,
		3515,
		9911,
		4397
	],
	"./details/common/featured-resources/featured-resources.js": [
		54397,
		9,
		5104,
		7913,
		8950,
		6064,
		8065,
		1994,
		510,
		4841,
		7604,
		7434,
		51,
		4146,
		8321,
		5986,
		1557,
		9708,
		7856,
		4581,
		3515,
		9911,
		4397
	],
	"./details/common/featured-resources/featured-resources.scss": [
		29911,
		9,
		9911
	],
	"./details/common/get-this-title": [
		94692,
		9,
		5104,
		8950,
		2933,
		6064,
		1440,
		3794,
		9923,
		3394,
		6838,
		8376,
		8989,
		3493,
		1133,
		8085,
		9276,
		1430,
		5672,
		7051,
		6922,
		5205,
		4692
	],
	"./details/common/get-this-title-files/amazon-associates-link": [
		67051,
		9,
		7051
	],
	"./details/common/get-this-title-files/amazon-associates-link.js": [
		67051,
		9,
		7051
	],
	"./details/common/get-this-title-files/get-this-title.scss": [
		25205,
		9,
		5205
	],
	"./details/common/get-this-title-files/give-before-pdf/give-before-pdf": [
		61133,
		9,
		5104,
		6064,
		3794,
		9923,
		6838,
		1133
	],
	"./details/common/get-this-title-files/give-before-pdf/give-before-pdf.js": [
		61133,
		9,
		5104,
		6064,
		3794,
		9923,
		6838,
		1133
	],
	"./details/common/get-this-title-files/give-before-pdf/give-before-pdf.scss": [
		16838,
		9,
		6838
	],
	"./details/common/get-this-title-files/give-before-pdf/thank-you-form": [
		59923,
		9,
		3794,
		9923
	],
	"./details/common/get-this-title-files/give-before-pdf/thank-you-form.js": [
		59923,
		9,
		3794,
		9923
	],
	"./details/common/get-this-title-files/give-before-pdf/thank-you-form.scss": [
		93794,
		9,
		3794
	],
	"./details/common/get-this-title-files/options": [
		26922,
		9,
		5104,
		8950,
		2933,
		6064,
		1440,
		3794,
		9923,
		3394,
		6838,
		8376,
		8989,
		3493,
		1133,
		8085,
		9276,
		1430,
		5672,
		7051,
		6922
	],
	"./details/common/get-this-title-files/options.js": [
		26922,
		9,
		5104,
		8950,
		2933,
		6064,
		1440,
		3794,
		9923,
		3394,
		6838,
		8376,
		8989,
		3493,
		1133,
		8085,
		9276,
		1430,
		5672,
		7051,
		6922
	],
	"./details/common/get-this-title-files/order-print-copy/order-print-copy": [
		78085,
		9,
		5104,
		3394,
		8085
	],
	"./details/common/get-this-title-files/order-print-copy/order-print-copy.js": [
		78085,
		9,
		5104,
		3394,
		8085
	],
	"./details/common/get-this-title-files/order-print-copy/order-print-copy.scss": [
		33394,
		9,
		3394
	],
	"./details/common/get-this-title-files/recommended-callout/recommended-callout": [
		35672,
		9,
		5104,
		8376,
		5672
	],
	"./details/common/get-this-title-files/recommended-callout/recommended-callout.js": [
		35672,
		9,
		5104,
		8376,
		5672
	],
	"./details/common/get-this-title-files/recommended-callout/recommended-callout.scss": [
		28376,
		9,
		8376
	],
	"./details/common/get-this-title-files/recommended-callout/use-callout-counter": [
		61430,
		9,
		1430
	],
	"./details/common/get-this-title-files/recommended-callout/use-callout-counter.js": [
		61430,
		9,
		1430
	],
	"./details/common/get-this-title-files/study-edge/study-edge": [
		59276,
		9,
		8989,
		9276
	],
	"./details/common/get-this-title-files/study-edge/study-edge.js": [
		59276,
		9,
		8989,
		9276
	],
	"./details/common/get-this-title-files/study-edge/study-edge.scss": [
		38989,
		9,
		8989
	],
	"./details/common/get-this-title.js": [
		94692,
		9,
		5104,
		8950,
		2933,
		6064,
		1440,
		3794,
		9923,
		3394,
		6838,
		8376,
		8989,
		3493,
		1133,
		8085,
		9276,
		1430,
		5672,
		7051,
		6922,
		5205,
		4692
	],
	"./details/common/hooks": [
		9128,
		9,
		7913,
		510,
		4841,
		9128
	],
	"./details/common/hooks.js": [
		9128,
		9,
		7913,
		510,
		4841,
		9128
	],
	"./details/common/let-us-know/let-us-know": [
		34510,
		9,
		5104,
		640,
		4510
	],
	"./details/common/let-us-know/let-us-know.js": [
		34510,
		9,
		5104,
		640,
		4510
	],
	"./details/common/let-us-know/let-us-know.scss": [
		60640,
		9,
		640
	],
	"./details/common/publication-info": [
		28290,
		9,
		7913,
		8950,
		510,
		8290
	],
	"./details/common/publication-info.js": [
		28290,
		9,
		7913,
		8950,
		510,
		8290
	],
	"./details/common/resource-box/request-form/request-form": [
		37856,
		9,
		7434,
		8321,
		7856
	],
	"./details/common/resource-box/request-form/request-form.js": [
		37856,
		9,
		7434,
		8321,
		7856
	],
	"./details/common/resource-box/request-form/request-form.scss": [
		38321,
		9,
		8321
	],
	"./details/common/resource-box/resource-box": [
		76376,
		9,
		8950,
		6376
	],
	"./details/common/resource-box/resource-box.js": [
		76376,
		9,
		8950,
		6376
	],
	"./details/common/resource-box/resource-box.scss": [
		91557,
		9,
		1557
	],
	"./details/common/resource-box/resource-boxes": [
		84581,
		9,
		5104,
		7913,
		8950,
		6064,
		8065,
		1994,
		510,
		4841,
		7604,
		7434,
		51,
		4146,
		8321,
		5986,
		1557,
		9708,
		7856,
		4581,
		3515
	],
	"./details/common/resource-box/resource-boxes.js": [
		84581,
		9,
		5104,
		7913,
		8950,
		6064,
		8065,
		1994,
		510,
		4841,
		7604,
		7434,
		51,
		4146,
		8321,
		5986,
		1557,
		9708,
		7856,
		4581,
		3515
	],
	"./details/common/savings-blurb": [
		88649,
		9,
		5104,
		586,
		6291,
		8649
	],
	"./details/common/savings-blurb.js": [
		88649,
		9,
		5104,
		586,
		6291,
		8649
	],
	"./details/common/savings-blurb.scss": [
		6291,
		9,
		6291
	],
	"./details/common/tab-utils": [
		325,
		9,
		8786
	],
	"./details/common/tab-utils.js": [
		325,
		9,
		8786
	],
	"./details/common/toc-slideout/context": [
		3493,
		9,
		3493
	],
	"./details/common/toc-slideout/context.js": [
		3493,
		9,
		3493
	],
	"./details/common/toc-slideout/toc-slideout": [
		93801,
		9,
		2933,
		3493,
		3801
	],
	"./details/common/toc-slideout/toc-slideout.js": [
		93801,
		9,
		2933,
		3493,
		3801
	],
	"./details/context": [
		43515,
		9,
		3515
	],
	"./details/context.js": [
		43515,
		9,
		3515
	],
	"./details/desktop-view/desktop-view": [
		77257,
		9,
		5104,
		7913,
		8950,
		2933,
		6524,
		510,
		6283,
		9300,
		3515,
		8290,
		405,
		9888,
		7927,
		4491,
		8581,
		333,
		8786,
		7257
	],
	"./details/desktop-view/desktop-view.js": [
		77257,
		9,
		5104,
		7913,
		8950,
		2933,
		6524,
		510,
		6283,
		9300,
		3515,
		8290,
		405,
		9888,
		7927,
		4491,
		8581,
		333,
		8786,
		7257
	],
	"./details/desktop-view/desktop-view.scss": [
		28581,
		9,
		8581
	],
	"./details/desktop-view/details-tab/details-tab": [
		54522,
		9,
		5104,
		7913,
		8950,
		2933,
		6064,
		1440,
		510,
		3794,
		9923,
		3394,
		6838,
		8376,
		8989,
		9300,
		3493,
		1133,
		8085,
		9276,
		1430,
		5672,
		586,
		7051,
		6922,
		8290,
		405,
		6291,
		9888,
		8649,
		5205,
		4522
	],
	"./details/desktop-view/details-tab/details-tab.js": [
		54522,
		9,
		5104,
		7913,
		8950,
		2933,
		6064,
		1440,
		510,
		3794,
		9923,
		3394,
		6838,
		8376,
		8989,
		9300,
		3493,
		1133,
		8085,
		9276,
		1430,
		5672,
		586,
		7051,
		6922,
		8290,
		405,
		6291,
		9888,
		8649,
		5205,
		4522
	],
	"./details/desktop-view/details-tab/details-tab.scss": [
		93111,
		9,
		3111
	],
	"./details/desktop-view/instructor-resource-tab/instructor-resource-tab": [
		41572,
		9,
		5104,
		7913,
		8950,
		6064,
		8065,
		1994,
		510,
		7801,
		4841,
		7604,
		7434,
		51,
		4146,
		8321,
		5986,
		2851,
		1557,
		9708,
		7856,
		4581,
		6320,
		3515,
		6376,
		9911,
		4397,
		1628,
		9786,
		891,
		9128,
		1572
	],
	"./details/desktop-view/instructor-resource-tab/instructor-resource-tab.js": [
		41572,
		9,
		5104,
		7913,
		8950,
		6064,
		8065,
		1994,
		510,
		7801,
		4841,
		7604,
		7434,
		51,
		4146,
		8321,
		5986,
		2851,
		1557,
		9708,
		7856,
		4581,
		6320,
		3515,
		6376,
		9911,
		4397,
		1628,
		9786,
		891,
		9128,
		1572
	],
	"./details/desktop-view/instructor-resource-tab/instructor-resource-tab.scss": [
		80891,
		9,
		891
	],
	"./details/desktop-view/instructor-resource-tab/partners/partners": [
		9786,
		9,
		5104,
		7801,
		2851,
		6320,
		1628,
		9786
	],
	"./details/desktop-view/instructor-resource-tab/partners/partners.js": [
		9786,
		9,
		5104,
		7801,
		2851,
		6320,
		1628,
		9786
	],
	"./details/desktop-view/instructor-resource-tab/partners/partners.scss": [
		81628,
		9,
		1628
	],
	"./details/desktop-view/student-resource-tab/student-resource-tab": [
		39004,
		9,
		5104,
		7913,
		8950,
		6064,
		8065,
		1994,
		510,
		4841,
		7604,
		7434,
		51,
		4146,
		8321,
		5986,
		1557,
		9708,
		7856,
		4581,
		3515,
		6376,
		7347,
		9004
	],
	"./details/desktop-view/student-resource-tab/student-resource-tab.js": [
		39004,
		9,
		5104,
		7913,
		8950,
		6064,
		8065,
		1994,
		510,
		4841,
		7604,
		7434,
		51,
		4146,
		8321,
		5986,
		1557,
		9708,
		7856,
		4581,
		3515,
		6376,
		7347,
		9004
	],
	"./details/desktop-view/student-resource-tab/student-resource-tab.scss": [
		7347,
		9,
		7347
	],
	"./details/desktop-view/videos-tab/videos-tab": [
		40333,
		9,
		7927,
		333
	],
	"./details/desktop-view/videos-tab/videos-tab.js": [
		40333,
		9,
		7927,
		333
	],
	"./details/desktop-view/videos-tab/videos-tab.scss": [
		57927,
		9,
		7927
	],
	"./details/details": [
		93244,
		9,
		5104,
		7913,
		8950,
		7850,
		6085,
		2933,
		6524,
		6064,
		3136,
		1440,
		510,
		1763,
		4841,
		6283,
		3794,
		9923,
		3394,
		6838,
		8376,
		8989,
		9300,
		3493,
		1133,
		8085,
		9276,
		1430,
		5672,
		7051,
		3515,
		3244
	],
	"./details/details.js": [
		93244,
		9,
		5104,
		7913,
		8950,
		7850,
		6085,
		2933,
		6524,
		6064,
		3136,
		1440,
		510,
		1763,
		4841,
		6283,
		3794,
		9923,
		3394,
		6838,
		8376,
		8989,
		9300,
		3493,
		1133,
		8085,
		9276,
		1430,
		5672,
		7051,
		3515,
		3244
	],
	"./details/details.scss": [
		61750,
		9,
		1750
	],
	"./details/phone-view/details-pane/details-pane": [
		39948,
		9,
		5104,
		7913,
		8950,
		510,
		9300,
		586,
		8290,
		405,
		6291,
		9888,
		8649,
		6937,
		4491,
		9948
	],
	"./details/phone-view/details-pane/details-pane.js": [
		39948,
		9,
		5104,
		7913,
		8950,
		510,
		9300,
		586,
		8290,
		405,
		6291,
		9888,
		8649,
		6937,
		4491,
		9948
	],
	"./details/phone-view/details-pane/details-pane.scss": [
		46937,
		9,
		6937
	],
	"./details/phone-view/instructor-resources-pane/instructor-resources-pane": [
		1049,
		9,
		5104,
		7913,
		8950,
		6524,
		6064,
		8065,
		1994,
		510,
		4841,
		7604,
		7434,
		51,
		4146,
		8321,
		5986,
		1557,
		9708,
		7856,
		4581,
		3515,
		6376,
		9911,
		4397,
		1253,
		1049
	],
	"./details/phone-view/instructor-resources-pane/instructor-resources-pane.js": [
		1049,
		9,
		5104,
		7913,
		8950,
		6524,
		6064,
		8065,
		1994,
		510,
		4841,
		7604,
		7434,
		51,
		4146,
		8321,
		5986,
		1557,
		9708,
		7856,
		4581,
		3515,
		6376,
		9911,
		4397,
		1253,
		1049
	],
	"./details/phone-view/instructor-resources-pane/instructor-resources-pane.scss": [
		41253,
		9,
		1253
	],
	"./details/phone-view/phone-view": [
		73563,
		9,
		5104,
		7913,
		8950,
		7850,
		2933,
		6524,
		6064,
		1440,
		510,
		1763,
		4841,
		3794,
		9923,
		3394,
		6838,
		8376,
		8989,
		9300,
		3493,
		1133,
		8085,
		9276,
		1430,
		5672,
		7051,
		3515,
		6922,
		8290,
		405,
		3563
	],
	"./details/phone-view/phone-view.js": [
		73563,
		9,
		5104,
		7913,
		8950,
		7850,
		2933,
		6524,
		6064,
		1440,
		510,
		1763,
		4841,
		3794,
		9923,
		3394,
		6838,
		8376,
		8989,
		9300,
		3493,
		1133,
		8085,
		9276,
		1430,
		5672,
		7051,
		3515,
		6922,
		8290,
		405,
		3563
	],
	"./details/phone-view/phone-view.scss": [
		83023,
		9,
		3023
	],
	"./details/phone-view/student-resources-pane/student-resources-pane": [
		65068,
		9,
		5104,
		7913,
		8950,
		6064,
		8065,
		1994,
		510,
		4841,
		7604,
		7434,
		51,
		4146,
		8321,
		5986,
		1557,
		9708,
		7856,
		4581,
		3515,
		6376,
		7028,
		5068
	],
	"./details/phone-view/student-resources-pane/student-resources-pane.js": [
		65068,
		9,
		5104,
		7913,
		8950,
		6064,
		8065,
		1994,
		510,
		4841,
		7604,
		7434,
		51,
		4146,
		8321,
		5986,
		1557,
		9708,
		7856,
		4581,
		3515,
		6376,
		7028,
		5068
	],
	"./details/phone-view/student-resources-pane/student-resources-pane.scss": [
		37028,
		9,
		7028
	],
	"./details/table-of-contents.scss": [
		22408,
		9,
		2408
	],
	"./errata-detail/detail/detail": [
		4208,
		9,
		7478,
		1001,
		4208
	],
	"./errata-detail/detail/detail.js": [
		4208,
		9,
		7478,
		1001,
		4208
	],
	"./errata-detail/detail/detail.scss": [
		21001,
		9,
		1001
	],
	"./errata-detail/errata-detail": [
		92999,
		9,
		6085,
		3136,
		7478,
		4268,
		1001,
		6401,
		4208,
		3931,
		2999
	],
	"./errata-detail/errata-detail.js": [
		92999,
		9,
		6085,
		3136,
		7478,
		4268,
		1001,
		6401,
		4208,
		3931,
		2999
	],
	"./errata-detail/errata-detail.scss": [
		3931,
		9,
		3931
	],
	"./errata-detail/progress-bar/progress-bar": [
		66401,
		9,
		4268,
		6401
	],
	"./errata-detail/progress-bar/progress-bar.js": [
		66401,
		9,
		4268,
		6401
	],
	"./errata-detail/progress-bar/progress-bar.scss": [
		34268,
		9,
		4268
	],
	"./errata-form/errata-form": [
		80062,
		9,
		5104,
		7913,
		2933,
		6064,
		1463,
		510,
		4841,
		13,
		7604,
		4917,
		932,
		1707,
		2452,
		4265,
		5193,
		2048,
		6264,
		9913,
		7197,
		902,
		296,
		4687,
		62
	],
	"./errata-form/errata-form-context": [
		12452,
		9,
		2452
	],
	"./errata-form/errata-form-context.js": [
		12452,
		9,
		2452
	],
	"./errata-form/errata-form.js": [
		80062,
		9,
		5104,
		7913,
		2933,
		6064,
		1463,
		510,
		4841,
		13,
		7604,
		4917,
		932,
		1707,
		2452,
		4265,
		5193,
		2048,
		6264,
		9913,
		7197,
		902,
		296,
		4687,
		62
	],
	"./errata-form/errata-form.scss": [
		24687,
		9,
		4687
	],
	"./errata-form/form/ErrorLocationSelector/ErrorLocationSelector": [
		67197,
		9,
		7913,
		510,
		4841,
		7604,
		1707,
		2452,
		4265,
		5193,
		7197
	],
	"./errata-form/form/ErrorLocationSelector/ErrorLocationSelector.js": [
		67197,
		9,
		7913,
		510,
		4841,
		7604,
		1707,
		2452,
		4265,
		5193,
		7197
	],
	"./errata-form/form/ErrorLocationSelector/ErrorLocationSelector.scss": [
		15193,
		9,
		5193
	],
	"./errata-form/form/ErrorLocationSelector/test-data": [
		26837,
		9,
		6837
	],
	"./errata-form/form/ErrorLocationSelector/test-data.js": [
		26837,
		9,
		6837
	],
	"./errata-form/form/ErrorLocationSelector/toc-selector": [
		74265,
		9,
		7913,
		510,
		4841,
		7604,
		1707,
		2452,
		4265
	],
	"./errata-form/form/ErrorLocationSelector/toc-selector.js": [
		74265,
		9,
		7913,
		510,
		4841,
		7604,
		1707,
		2452,
		4265
	],
	"./errata-form/form/ErrorSourceSelector": [
		86264,
		9,
		1707,
		2452,
		6264
	],
	"./errata-form/form/ErrorSourceSelector.js": [
		86264,
		9,
		1707,
		2452,
		6264
	],
	"./errata-form/form/ErrorTypeSelector": [
		89913,
		9,
		1707,
		9913
	],
	"./errata-form/form/ErrorTypeSelector.js": [
		89913,
		9,
		1707,
		9913
	],
	"./errata-form/form/FileUploader": [
		50902,
		9,
		5104,
		902
	],
	"./errata-form/form/FileUploader.js": [
		50902,
		9,
		5104,
		902
	],
	"./errata-form/form/InvalidMessage": [
		61707,
		9,
		1707
	],
	"./errata-form/form/InvalidMessage.js": [
		61707,
		9,
		1707
	],
	"./errata-form/form/form": [
		80296,
		9,
		5104,
		7913,
		6064,
		510,
		4841,
		7604,
		1707,
		2452,
		4265,
		5193,
		2048,
		6264,
		9913,
		7197,
		902,
		296
	],
	"./errata-form/form/form.js": [
		80296,
		9,
		5104,
		7913,
		6064,
		510,
		4841,
		7604,
		1707,
		2452,
		4265,
		5193,
		2048,
		6264,
		9913,
		7197,
		902,
		296
	],
	"./errata-form/form/form.scss": [
		62048,
		9,
		2048
	],
	"./errata-summary/errata-summary": [
		77336,
		9,
		5104,
		6085,
		2933,
		3136,
		7478,
		9807,
		3031,
		9168,
		7885,
		1502,
		1800,
		7336
	],
	"./errata-summary/errata-summary.js": [
		77336,
		9,
		5104,
		6085,
		2933,
		3136,
		7478,
		9807,
		3031,
		9168,
		7885,
		1502,
		1800,
		7336
	],
	"./errata-summary/errata-summary.scss": [
		41800,
		9,
		1800
	],
	"./errata-summary/hero/hero": [
		27885,
		9,
		5104,
		6085,
		3136,
		3031,
		7885
	],
	"./errata-summary/hero/hero.js": [
		27885,
		9,
		5104,
		6085,
		3136,
		3031,
		7885
	],
	"./errata-summary/hero/hero.scss": [
		13031,
		9,
		3031
	],
	"./errata-summary/table/table": [
		49168,
		9,
		2933,
		7478,
		9807,
		9168
	],
	"./errata-summary/table/table.js": [
		49168,
		9,
		2933,
		7478,
		9807,
		9168
	],
	"./errata-summary/table/table.scss": [
		9807,
		9,
		9807
	],
	"./faq/chat-button": [
		2537,
		9,
		1776,
		2537
	],
	"./faq/chat-button.js": [
		2537,
		9,
		1776,
		2537
	],
	"./faq/chat-button.scss": [
		21776,
		9,
		1776
	],
	"./faq/faq": [
		91029,
		9,
		6085,
		3136,
		1776,
		1304,
		2537,
		1029
	],
	"./faq/faq.js": [
		91029,
		9,
		6085,
		3136,
		1776,
		1304,
		2537,
		1029
	],
	"./faq/faq.scss": [
		31304,
		9,
		1304
	],
	"./footer-page/footer-page": [
		53641,
		9,
		6085,
		2977,
		3641
	],
	"./footer-page/footer-page.js": [
		53641,
		9,
		6085,
		2977,
		3641
	],
	"./footer-page/footer-page.scss": [
		22977,
		9,
		2977
	],
	"./foundation/foundation": [
		38101,
		9,
		6085,
		3136,
		6324,
		5528,
		8101
	],
	"./foundation/foundation.js": [
		38101,
		9,
		6085,
		3136,
		6324,
		5528,
		8101
	],
	"./foundation/foundation.scss": [
		35528,
		9,
		5528
	],
	"./general/general": [
		79048,
		9
	],
	"./general/general.js": [
		79048,
		9
	],
	"./general/general.scss": [
		25383,
		9
	],
	"./global-reach/global-reach": [
		6386,
		9,
		5104,
		6085,
		3136,
		6297,
		9546,
		6827,
		4682,
		1803,
		3606,
		4783,
		946,
		6386
	],
	"./global-reach/global-reach.js": [
		6386,
		9,
		5104,
		6085,
		3136,
		6297,
		9546,
		6827,
		4682,
		1803,
		3606,
		4783,
		946,
		6386
	],
	"./global-reach/map/map": [
		90946,
		9,
		9546,
		946
	],
	"./global-reach/map/map.js": [
		90946,
		9,
		9546,
		946
	],
	"./global-reach/map/map.scss": [
		59546,
		9,
		9546
	],
	"./global-reach/schoolmap/schoolmap": [
		63606,
		9,
		5104,
		4682,
		3606
	],
	"./global-reach/schoolmap/schoolmap.js": [
		63606,
		9,
		5104,
		4682,
		3606
	],
	"./global-reach/schoolmap/schoolmap.scss": [
		44682,
		9,
		4682
	],
	"./global-reach/statistics/stat": [
		74783,
		9,
		6827,
		4783
	],
	"./global-reach/statistics/stat.js": [
		74783,
		9,
		6827,
		4783
	],
	"./global-reach/statistics/stat.scss": [
		36827,
		9,
		6827
	],
	"./global-reach/studentinfo/studentinfo": [
		51803,
		9,
		6297,
		1803
	],
	"./global-reach/studentinfo/studentinfo.js": [
		51803,
		9,
		6297,
		1803
	],
	"./global-reach/studentinfo/studentinfo.scss": [
		26297,
		9,
		6297
	],
	"./home/banner/banner": [
		4327,
		9,
		6324,
		9081,
		7018,
		4327
	],
	"./home/banner/banner.js": [
		4327,
		9,
		6324,
		9081,
		7018,
		4327
	],
	"./home/banner/banner.scss": [
		37018,
		9,
		7018
	],
	"./home/features/features": [
		87436,
		9,
		5104,
		9081,
		8532,
		7436
	],
	"./home/features/features.js": [
		87436,
		9,
		5104,
		9081,
		8532,
		7436
	],
	"./home/features/features.scss": [
		98532,
		9,
		8532
	],
	"./home/home": [
		73610,
		9,
		5104,
		570,
		6085,
		3136,
		6324,
		9081,
		9457,
		8532,
		2592,
		2306,
		7018,
		1827,
		7436,
		4327,
		1448,
		6788,
		8496,
		3610
	],
	"./home/home.js": [
		73610,
		9,
		5104,
		570,
		6085,
		3136,
		6324,
		9081,
		9457,
		8532,
		2592,
		2306,
		7018,
		1827,
		7436,
		4327,
		1448,
		6788,
		8496,
		3610
	],
	"./home/home.scss": [
		1827,
		9,
		1827
	],
	"./home/map/map": [
		8496,
		9,
		2306,
		8496
	],
	"./home/map/map.js": [
		8496,
		9,
		2306,
		8496
	],
	"./home/map/map.scss": [
		22306,
		9,
		2306
	],
	"./home/quotes/quotes": [
		31448,
		9,
		9081,
		9457,
		1448
	],
	"./home/quotes/quotes.js": [
		31448,
		9,
		9081,
		9457,
		1448
	],
	"./home/quotes/quotes.scss": [
		59457,
		9,
		9457
	],
	"./home/whats-openstax/whats-openstax": [
		56788,
		9,
		6324,
		9081,
		2592,
		6788
	],
	"./home/whats-openstax/whats-openstax.js": [
		56788,
		9,
		6324,
		9081,
		2592,
		6788
	],
	"./home/whats-openstax/whats-openstax.scss": [
		22592,
		9,
		2592
	],
	"./impact/disruption": [
		67422,
		9,
		8434,
		7422
	],
	"./impact/disruption.js": [
		67422,
		9,
		8434,
		7422
	],
	"./impact/disruption.scss": [
		28434,
		9,
		8434
	],
	"./impact/give": [
		54656,
		9,
		9718,
		4656
	],
	"./impact/give.js": [
		54656,
		9,
		9718,
		4656
	],
	"./impact/give.scss": [
		69718,
		9,
		9718
	],
	"./impact/impact": [
		62188,
		9,
		5104,
		570,
		6085,
		6524,
		6064,
		3136,
		759,
		6324,
		1022,
		633,
		5635,
		7119,
		72,
		5074,
		1383,
		9718,
		3862,
		2074,
		6058,
		8434,
		1759,
		6072,
		9437,
		2181,
		7422,
		4656,
		2188
	],
	"./impact/impact.js": [
		62188,
		9,
		5104,
		570,
		6085,
		6524,
		6064,
		3136,
		759,
		6324,
		1022,
		633,
		5635,
		7119,
		72,
		5074,
		1383,
		9718,
		3862,
		2074,
		6058,
		8434,
		1759,
		6072,
		9437,
		2181,
		7422,
		4656,
		2188
	],
	"./impact/impact.scss": [
		11759,
		9,
		1759
	],
	"./impact/our-reach": [
		29437,
		9,
		5104,
		6524,
		6324,
		5074,
		2074,
		6058,
		9437
	],
	"./impact/our-reach.js": [
		29437,
		9,
		5104,
		6524,
		6324,
		5074,
		2074,
		6058,
		9437
	],
	"./impact/our-reach.scss": [
		12074,
		9,
		2074
	],
	"./impact/quote": [
		62181,
		9,
		3862,
		2181
	],
	"./impact/quote.js": [
		62181,
		9,
		3862,
		2181
	],
	"./impact/quote.scss": [
		3862,
		9,
		3862
	],
	"./impact/testimonials": [
		36072,
		9,
		5104,
		6085,
		6524,
		6064,
		759,
		6324,
		1022,
		633,
		5635,
		7119,
		72,
		1383,
		6058,
		6072
	],
	"./impact/testimonials.js": [
		36072,
		9,
		5104,
		6085,
		6524,
		6064,
		759,
		6324,
		1022,
		633,
		5635,
		7119,
		72,
		1383,
		6058,
		6072
	],
	"./impact/testimonials.scss": [
		91383,
		9,
		1383
	],
	"./institutional-partnership-application/institutional-partnership-application": [
		3951,
		9,
		7913,
		6085,
		3136,
		3147,
		3951
	],
	"./institutional-partnership-application/institutional-partnership-application.js": [
		3951,
		9,
		7913,
		6085,
		3136,
		3147,
		3951
	],
	"./institutional-partnership-application/institutional-partnership-application.scss": [
		3147,
		9,
		3147
	],
	"./institutional-partnership/institutional-partnership": [
		76691,
		9,
		5104,
		7913,
		570,
		6085,
		6524,
		6064,
		3136,
		8065,
		9081,
		7523,
		8123,
		8799,
		2482,
		1234,
		5795,
		4506,
		4003,
		5289,
		1467,
		8875,
		1939,
		7509,
		3419,
		2031,
		9377,
		2760,
		4835,
		592,
		9894,
		6691
	],
	"./institutional-partnership/institutional-partnership.js": [
		76691,
		9,
		5104,
		7913,
		570,
		6085,
		6524,
		6064,
		3136,
		8065,
		9081,
		7523,
		8123,
		8799,
		2482,
		1234,
		5795,
		4506,
		4003,
		5289,
		1467,
		8875,
		1939,
		7509,
		3419,
		2031,
		9377,
		2760,
		4835,
		592,
		9894,
		6691
	],
	"./institutional-partnership/institutional-partnership.scss": [
		27509,
		9,
		7509
	],
	"./institutional-partnership/sections/about/about": [
		20520,
		9,
		9081,
		8875,
		520
	],
	"./institutional-partnership/sections/about/about.js": [
		20520,
		9,
		9081,
		8875,
		520
	],
	"./institutional-partnership/sections/about/about.scss": [
		28875,
		9,
		8875
	],
	"./institutional-partnership/sections/banner/banner": [
		59084,
		9,
		9081,
		4003,
		9084
	],
	"./institutional-partnership/sections/banner/banner.js": [
		59084,
		9,
		9081,
		4003,
		9084
	],
	"./institutional-partnership/sections/banner/banner.scss": [
		94003,
		9,
		4003
	],
	"./institutional-partnership/sections/big-quote/big-quote": [
		44835,
		9,
		8123,
		4835
	],
	"./institutional-partnership/sections/big-quote/big-quote.js": [
		44835,
		9,
		8123,
		4835
	],
	"./institutional-partnership/sections/big-quote/big-quote.scss": [
		68123,
		9,
		8123
	],
	"./institutional-partnership/sections/overlapping-quote/overlapping-quote": [
		30592,
		9,
		1234,
		592
	],
	"./institutional-partnership/sections/overlapping-quote/overlapping-quote.js": [
		30592,
		9,
		1234,
		592
	],
	"./institutional-partnership/sections/overlapping-quote/overlapping-quote.scss": [
		21234,
		9,
		1234
	],
	"./institutional-partnership/sections/participants/established-partners/established-partners": [
		91939,
		9,
		7523,
		1939
	],
	"./institutional-partnership/sections/participants/established-partners/established-partners.js": [
		91939,
		9,
		7523,
		1939
	],
	"./institutional-partnership/sections/participants/established-partners/established-partners.scss": [
		27523,
		9,
		7523
	],
	"./institutional-partnership/sections/participants/participants": [
		52031,
		9,
		5104,
		7913,
		6064,
		7523,
		1467,
		1939,
		2031
	],
	"./institutional-partnership/sections/participants/participants.js": [
		52031,
		9,
		5104,
		7913,
		6064,
		7523,
		1467,
		1939,
		2031
	],
	"./institutional-partnership/sections/participants/participants.scss": [
		51467,
		9,
		1467
	],
	"./institutional-partnership/sections/promoting/promoting": [
		29377,
		9,
		2482,
		9377
	],
	"./institutional-partnership/sections/promoting/promoting.js": [
		29377,
		9,
		2482,
		9377
	],
	"./institutional-partnership/sections/promoting/promoting.scss": [
		52482,
		9,
		2482
	],
	"./institutional-partnership/sections/results/results": [
		12760,
		9,
		4506,
		2760
	],
	"./institutional-partnership/sections/results/results.js": [
		12760,
		9,
		4506,
		2760
	],
	"./institutional-partnership/sections/results/results.scss": [
		14506,
		9,
		4506
	],
	"./institutional-partnership/sections/sign-up/sign-up": [
		17601,
		9,
		5104,
		8799,
		7601
	],
	"./institutional-partnership/sections/sign-up/sign-up.js": [
		17601,
		9,
		5104,
		8799,
		7601
	],
	"./institutional-partnership/sections/sign-up/sign-up.scss": [
		98799,
		9,
		8799
	],
	"./institutional-partnership/sections/small-quote/small-quote": [
		18825,
		9,
		5289,
		8825
	],
	"./institutional-partnership/sections/small-quote/small-quote.js": [
		18825,
		9,
		5289,
		8825
	],
	"./institutional-partnership/sections/small-quote/small-quote.scss": [
		5289,
		9,
		5289
	],
	"./institutional-partnership/sections/speaking/speaking": [
		69894,
		9,
		5795,
		9894
	],
	"./institutional-partnership/sections/speaking/speaking.js": [
		69894,
		9,
		5795,
		9894
	],
	"./institutional-partnership/sections/speaking/speaking.scss": [
		95795,
		9,
		5795
	],
	"./interest/interest": [
		71591,
		9,
		5104,
		6085,
		2933,
		3136,
		8065,
		1994,
		1463,
		13,
		4917,
		932,
		6844,
		9673,
		2151,
		806,
		2462,
		4978,
		1591
	],
	"./interest/interest.js": [
		71591,
		9,
		5104,
		6085,
		2933,
		3136,
		8065,
		1994,
		1463,
		13,
		4917,
		932,
		6844,
		9673,
		2151,
		806,
		2462,
		4978,
		1591
	],
	"./interest/interest.scss": [
		74978,
		9,
		4978
	],
	"./llph/llph": [
		56933,
		9,
		6085,
		3136,
		5885,
		6933
	],
	"./llph/llph.js": [
		56933,
		9,
		6085,
		3136,
		5885,
		6933
	],
	"./llph/llph.scss": [
		65885,
		9,
		5885
	],
	"./openstax-tutor/banner/banner": [
		9661,
		9,
		6324,
		9249,
		6139,
		3441,
		9661
	],
	"./openstax-tutor/banner/banner.js": [
		9661,
		9,
		6324,
		9249,
		6139,
		3441,
		9661
	],
	"./openstax-tutor/banner/banner.scss": [
		86139,
		9,
		6139
	],
	"./openstax-tutor/button-row/button-row": [
		93441,
		9,
		9249,
		3441
	],
	"./openstax-tutor/button-row/button-row.js": [
		93441,
		9,
		9249,
		3441
	],
	"./openstax-tutor/button-row/button-row.scss": [
		69249,
		9,
		9249
	],
	"./openstax-tutor/common": [
		94201,
		9,
		2739,
		4201
	],
	"./openstax-tutor/common.js": [
		94201,
		9,
		2739,
		4201
	],
	"./openstax-tutor/common.scss": [
		82739,
		9,
		2739
	],
	"./openstax-tutor/cost/cost": [
		87411,
		9,
		2739,
		4201,
		1794,
		7411
	],
	"./openstax-tutor/cost/cost.js": [
		87411,
		9,
		2739,
		4201,
		1794,
		7411
	],
	"./openstax-tutor/cost/cost.scss": [
		41794,
		9,
		1794
	],
	"./openstax-tutor/faq/faq": [
		23040,
		9,
		5104,
		2739,
		4201,
		1151,
		3040
	],
	"./openstax-tutor/faq/faq.js": [
		23040,
		9,
		5104,
		2739,
		4201,
		1151,
		3040
	],
	"./openstax-tutor/faq/faq.scss": [
		11151,
		9,
		1151
	],
	"./openstax-tutor/features/features": [
		9223,
		9,
		2739,
		4201,
		787,
		9223
	],
	"./openstax-tutor/features/features.js": [
		9223,
		9,
		2739,
		4201,
		787,
		9223
	],
	"./openstax-tutor/features/features.scss": [
		40787,
		9,
		787
	],
	"./openstax-tutor/feedback/feedback": [
		96477,
		9,
		6324,
		2739,
		4201,
		9875,
		6477
	],
	"./openstax-tutor/feedback/feedback.js": [
		96477,
		9,
		6324,
		2739,
		4201,
		9875,
		6477
	],
	"./openstax-tutor/feedback/feedback.scss": [
		29875,
		9,
		9875
	],
	"./openstax-tutor/materials/materials": [
		37769,
		9,
		2739,
		4201,
		7386,
		7769
	],
	"./openstax-tutor/materials/materials.js": [
		37769,
		9,
		2739,
		4201,
		7386,
		7769
	],
	"./openstax-tutor/materials/materials.scss": [
		87386,
		9,
		7386
	],
	"./openstax-tutor/openstax-tutor": [
		4180,
		9,
		5104,
		570,
		6085,
		6524,
		3136,
		8065,
		759,
		6324,
		2739,
		4201,
		9249,
		8061,
		9875,
		1794,
		6139,
		9075,
		1151,
		7386,
		787,
		3441,
		3419,
		9774,
		6477,
		541,
		3040,
		7411,
		9661,
		9223,
		7769,
		4180
	],
	"./openstax-tutor/openstax-tutor.js": [
		4180,
		9,
		5104,
		570,
		6085,
		6524,
		3136,
		8065,
		759,
		6324,
		2739,
		4201,
		9249,
		8061,
		9875,
		1794,
		6139,
		9075,
		1151,
		7386,
		787,
		3441,
		3419,
		9774,
		6477,
		541,
		3040,
		7411,
		9661,
		9223,
		7769,
		4180
	],
	"./openstax-tutor/openstax-tutor.scss": [
		20541,
		9,
		541
	],
	"./openstax-tutor/quote-box/quote-box": [
		47387,
		9,
		9075,
		7387
	],
	"./openstax-tutor/quote-box/quote-box.js": [
		47387,
		9,
		9075,
		7387
	],
	"./openstax-tutor/quote-box/quote-box.scss": [
		99075,
		9,
		9075
	],
	"./openstax-tutor/webinars/webinars": [
		29774,
		9,
		5104,
		6524,
		759,
		2739,
		4201,
		8061,
		9774
	],
	"./openstax-tutor/webinars/webinars.js": [
		29774,
		9,
		5104,
		6524,
		759,
		2739,
		4201,
		8061,
		9774
	],
	"./openstax-tutor/webinars/webinars.scss": [
		88061,
		9,
		8061
	],
	"./partners/active-filters/active-filters": [
		96379,
		9,
		7801,
		2754,
		7091,
		6379
	],
	"./partners/active-filters/active-filters.js": [
		96379,
		9,
		7801,
		2754,
		7091,
		6379
	],
	"./partners/active-filters/active-filters.scss": [
		52754,
		9,
		2754
	],
	"./partners/active-filters/filter-remover": [
		27091,
		9,
		7091
	],
	"./partners/active-filters/filter-remover.js": [
		27091,
		9,
		7091
	],
	"./partners/analytics-events": [
		42851,
		9,
		7801,
		2851
	],
	"./partners/analytics-events.js": [
		42851,
		9,
		7801,
		2851
	],
	"./partners/controls/advanced-options/advanced-options": [
		24622,
		9,
		5104,
		7913,
		7850,
		2933,
		1763,
		9660,
		3217,
		4622
	],
	"./partners/controls/advanced-options/advanced-options.js": [
		24622,
		9,
		5104,
		7913,
		7850,
		2933,
		1763,
		9660,
		3217,
		4622
	],
	"./partners/controls/book-options/book-options": [
		98657,
		9,
		5104,
		2933,
		9660,
		3217,
		497,
		6656
	],
	"./partners/controls/book-options/book-options.js": [
		98657,
		9,
		5104,
		2933,
		9660,
		3217,
		497,
		6656
	],
	"./partners/controls/book-options/book-options.scss": [
		50497,
		9,
		497
	],
	"./partners/controls/button-with-popover.scss": [
		64007,
		9,
		4007
	],
	"./partners/controls/checkboxes-linked-to-store/checkboxes-linked-to-store": [
		43217,
		9,
		5104,
		2933,
		9660,
		3217
	],
	"./partners/controls/checkboxes-linked-to-store/checkboxes-linked-to-store.js": [
		43217,
		9,
		5104,
		2933,
		9660,
		3217
	],
	"./partners/controls/checkboxes-linked-to-store/checkboxes-linked-to-store.scss": [
		69660,
		9,
		9660
	],
	"./partners/controls/controls": [
		25570,
		9,
		5104,
		7913,
		7850,
		2933,
		8065,
		1763,
		7801,
		9660,
		3217,
		497,
		5507,
		7517,
		4007,
		4622,
		6656,
		2350,
		5570
	],
	"./partners/controls/controls.js": [
		25570,
		9,
		5104,
		7913,
		7850,
		2933,
		8065,
		1763,
		7801,
		9660,
		3217,
		497,
		5507,
		7517,
		4007,
		4622,
		6656,
		2350,
		5570
	],
	"./partners/controls/controls.scss": [
		7517,
		9,
		7517
	],
	"./partners/controls/options-list/options-list": [
		72350,
		9,
		2933,
		5507,
		2350
	],
	"./partners/controls/options-list/options-list.js": [
		72350,
		9,
		2933,
		5507,
		2350
	],
	"./partners/controls/options-list/options-list.scss": [
		85507,
		9,
		5507
	],
	"./partners/mobile-controls/mobile-controls": [
		39347,
		9,
		5104,
		7913,
		7850,
		2933,
		6524,
		8065,
		1763,
		7801,
		9660,
		3217,
		497,
		5507,
		7517,
		4007,
		2754,
		4622,
		6656,
		2350,
		7091,
		2863,
		5570,
		6379,
		9347
	],
	"./partners/mobile-controls/mobile-controls.js": [
		39347,
		9,
		5104,
		7913,
		7850,
		2933,
		6524,
		8065,
		1763,
		7801,
		9660,
		3217,
		497,
		5507,
		7517,
		4007,
		2754,
		4622,
		6656,
		2350,
		7091,
		2863,
		5570,
		6379,
		9347
	],
	"./partners/mobile-controls/mobile-controls.scss": [
		92863,
		9,
		2863
	],
	"./partners/partner-details/carousel/carousel": [
		889,
		9,
		5104,
		6524,
		759,
		3622,
		889
	],
	"./partners/partner-details/carousel/carousel.js": [
		889,
		9,
		5104,
		6524,
		759,
		3622,
		889
	],
	"./partners/partner-details/carousel/carousel.scss": [
		63622,
		9,
		3622
	],
	"./partners/partner-details/info-request-form/info-request-form": [
		97215,
		9,
		5104,
		7913,
		2933,
		8065,
		1994,
		1463,
		7801,
		13,
		4917,
		932,
		131,
		6844,
		813,
		9673,
		2151,
		4034,
		2937,
		7215
	],
	"./partners/partner-details/info-request-form/info-request-form.js": [
		97215,
		9,
		5104,
		7913,
		2933,
		8065,
		1994,
		1463,
		7801,
		13,
		4917,
		932,
		131,
		6844,
		813,
		9673,
		2151,
		4034,
		2937,
		7215
	],
	"./partners/partner-details/info-request-form/info-request-form.scss": [
		22937,
		9,
		2937
	],
	"./partners/partner-details/partner-context": [
		70813,
		9,
		7913,
		131,
		813
	],
	"./partners/partner-details/partner-context.js": [
		70813,
		9,
		7913,
		131,
		813
	],
	"./partners/partner-details/partner-details": [
		77963,
		9,
		5104,
		7913,
		2933,
		6524,
		8065,
		1994,
		1463,
		7801,
		13,
		4917,
		759,
		932,
		6283,
		2851,
		6320,
		131,
		6844,
		813,
		9673,
		2151,
		4034,
		4427,
		2937,
		3622,
		7215,
		2063,
		2624,
		889,
		7963
	],
	"./partners/partner-details/partner-details.js": [
		77963,
		9,
		5104,
		7913,
		2933,
		6524,
		8065,
		1994,
		1463,
		7801,
		13,
		4917,
		759,
		932,
		6283,
		2851,
		6320,
		131,
		6844,
		813,
		9673,
		2151,
		4034,
		4427,
		2937,
		3622,
		7215,
		2063,
		2624,
		889,
		7963
	],
	"./partners/partner-details/partner-details.scss": [
		62063,
		9,
		2063
	],
	"./partners/partner-details/reviews/page-context": [
		1382,
		9,
		1382
	],
	"./partners/partner-details/reviews/page-context.js": [
		1382,
		9,
		1382
	],
	"./partners/partner-details/reviews/rating-form": [
		13472,
		9,
		5104,
		7913,
		7801,
		2851,
		131,
		813,
		5224,
		1382,
		3472
	],
	"./partners/partner-details/reviews/rating-form.js": [
		13472,
		9,
		5104,
		7913,
		7801,
		2851,
		131,
		813,
		5224,
		1382,
		3472
	],
	"./partners/partner-details/reviews/rating-form.scss": [
		45224,
		9,
		5224
	],
	"./partners/partner-details/reviews/review-context": [
		12289,
		7,
		2289
	],
	"./partners/partner-details/reviews/review-context.js": [
		12289,
		7,
		2289
	],
	"./partners/partner-details/reviews/reviews": [
		97930,
		9,
		5104,
		7913,
		7801,
		2851,
		6320,
		131,
		813,
		5224,
		1382,
		3472,
		3519,
		2590,
		9522,
		7930
	],
	"./partners/partner-details/reviews/reviews.js": [
		97930,
		9,
		5104,
		7913,
		7801,
		2851,
		6320,
		131,
		813,
		5224,
		1382,
		3472,
		3519,
		2590,
		9522,
		7930
	],
	"./partners/partner-details/reviews/reviews.scss": [
		59522,
		9,
		9522
	],
	"./partners/partner-details/reviews/user-review": [
		72590,
		9,
		5104,
		7913,
		7801,
		2851,
		6320,
		131,
		813,
		5224,
		1382,
		3472,
		3519,
		2590
	],
	"./partners/partner-details/reviews/user-review.js": [
		72590,
		9,
		5104,
		7913,
		7801,
		2851,
		6320,
		131,
		813,
		5224,
		1382,
		3472,
		3519,
		2590
	],
	"./partners/partner-details/reviews/user-review.scss": [
		3519,
		9,
		3519
	],
	"./partners/partner-details/synopsis/synopsis": [
		22624,
		9,
		5104,
		7801,
		2851,
		6320,
		4427,
		2624
	],
	"./partners/partner-details/synopsis/synopsis.js": [
		22624,
		9,
		5104,
		7801,
		2851,
		6320,
		4427,
		2624
	],
	"./partners/partner-details/synopsis/synopsis.scss": [
		24427,
		9,
		4427
	],
	"./partners/partners": [
		96225,
		9,
		5104,
		7913,
		7850,
		6085,
		2933,
		6524,
		6064,
		3136,
		8065,
		1994,
		1463,
		1763,
		7801,
		13,
		4917,
		759,
		932,
		6283,
		2851,
		6320,
		131,
		6844,
		813,
		9673,
		2151,
		9660,
		4034,
		4427,
		2937,
		6225
	],
	"./partners/partners.js": [
		96225,
		9,
		5104,
		7913,
		7850,
		6085,
		2933,
		6524,
		6064,
		3136,
		8065,
		1994,
		1463,
		1763,
		7801,
		13,
		4917,
		759,
		932,
		6283,
		2851,
		6320,
		131,
		6844,
		813,
		9673,
		2151,
		9660,
		4034,
		4427,
		2937,
		6225
	],
	"./partners/partners.scss": [
		16010,
		9,
		6010
	],
	"./partners/results/dialog-context": [
		90131,
		9,
		131
	],
	"./partners/results/dialog-context.js": [
		90131,
		9,
		131
	],
	"./partners/results/result-grid": [
		9080,
		9,
		5104,
		7913,
		2933,
		6524,
		6064,
		8065,
		1994,
		1463,
		7801,
		13,
		4917,
		759,
		932,
		6283,
		2851,
		6320,
		131,
		6844,
		813,
		9673,
		2151,
		4034,
		4427,
		2937,
		3622,
		7215,
		2063,
		2624,
		889,
		9080
	],
	"./partners/results/result-grid.js": [
		9080,
		9,
		5104,
		7913,
		2933,
		6524,
		6064,
		8065,
		1994,
		1463,
		7801,
		13,
		4917,
		759,
		932,
		6283,
		2851,
		6320,
		131,
		6844,
		813,
		9673,
		2151,
		4034,
		4427,
		2937,
		3622,
		7215,
		2063,
		2624,
		889,
		9080
	],
	"./partners/results/results": [
		723,
		9,
		5104,
		7913,
		2933,
		6524,
		6064,
		8065,
		1994,
		1463,
		7801,
		13,
		4917,
		759,
		932,
		6283,
		2851,
		6320,
		131,
		6844,
		813,
		9673,
		2151,
		4034,
		4427,
		2937,
		3622,
		7215,
		2063,
		2624,
		889,
		723
	],
	"./partners/results/results.js": [
		723,
		9,
		5104,
		7913,
		2933,
		6524,
		6064,
		8065,
		1994,
		1463,
		7801,
		13,
		4917,
		759,
		932,
		6283,
		2851,
		6320,
		131,
		6844,
		813,
		9673,
		2151,
		4034,
		4427,
		2937,
		3622,
		7215,
		2063,
		2624,
		889,
		723
	],
	"./partners/results/results.scss": [
		2384,
		9,
		2384
	],
	"./partners/search-context": [
		67801,
		9,
		7801
	],
	"./partners/search-context.js": [
		67801,
		9,
		7801
	],
	"./press/article/article": [
		62354,
		9,
		6085,
		1022,
		633,
		5635,
		2354
	],
	"./press/article/article.js": [
		62354,
		9,
		6085,
		1022,
		633,
		5635,
		2354
	],
	"./press/bookings/bookings": [
		27340,
		9,
		6085,
		2004,
		5625,
		7340
	],
	"./press/bookings/bookings.js": [
		27340,
		9,
		6085,
		2004,
		5625,
		7340
	],
	"./press/bookings/bookings.scss": [
		5625,
		9,
		5625
	],
	"./press/inquiries/inquiries": [
		19013,
		9,
		5104,
		6085,
		2004,
		8424,
		9013
	],
	"./press/inquiries/inquiries.js": [
		19013,
		9,
		5104,
		6085,
		2004,
		8424,
		9013
	],
	"./press/inquiries/inquiries.scss": [
		18424,
		9,
		8424
	],
	"./press/mobile-selector/mobile-selector": [
		72626,
		9,
		5104,
		341,
		2626
	],
	"./press/mobile-selector/mobile-selector.js": [
		72626,
		9,
		5104,
		341,
		2626
	],
	"./press/mobile-selector/mobile-selector.scss": [
		90341,
		9,
		341
	],
	"./press/page-context": [
		82004,
		9,
		6085,
		2004
	],
	"./press/page-context.js": [
		82004,
		9,
		6085,
		2004
	],
	"./press/press": [
		85482,
		9,
		5104,
		6085,
		2933,
		1022,
		633,
		5635,
		2004,
		8424,
		341,
		5625,
		9170,
		9013,
		1026,
		2354,
		7340,
		2626,
		4222,
		5482
	],
	"./press/press-excerpt/press-excerpt": [
		64222,
		9,
		5104,
		1022,
		9170,
		4222
	],
	"./press/press-excerpt/press-excerpt.js": [
		64222,
		9,
		5104,
		1022,
		9170,
		4222
	],
	"./press/press-excerpt/press-excerpt.scss": [
		79170,
		9,
		9170
	],
	"./press/press.js": [
		85482,
		9,
		5104,
		6085,
		2933,
		1022,
		633,
		5635,
		2004,
		8424,
		341,
		5625,
		9170,
		9013,
		1026,
		2354,
		7340,
		2626,
		4222,
		5482
	],
	"./press/press.scss": [
		71026,
		9,
		1026
	],
	"./renewal-form/renewal-form": [
		31721,
		9,
		5104,
		2933,
		1463,
		13,
		4034,
		5787,
		1721
	],
	"./renewal-form/renewal-form.js": [
		31721,
		9,
		5104,
		2933,
		1463,
		13,
		4034,
		5787,
		1721
	],
	"./renewal-form/renewal-form.scss": [
		5787,
		9,
		5787
	],
	"./research/components/contact-us": [
		88998,
		9,
		4931,
		8490,
		5837,
		3802,
		8998
	],
	"./research/components/contact-us.js": [
		88998,
		9,
		4931,
		8490,
		5837,
		3802,
		8998
	],
	"./research/components/funders": [
		60893,
		9,
		4931,
		8490,
		5837,
		3802,
		893
	],
	"./research/components/funders.js": [
		60893,
		9,
		4931,
		8490,
		5837,
		3802,
		893
	],
	"./research/components/header": [
		12770,
		9,
		5104,
		4931,
		8490,
		5837,
		3802,
		2770
	],
	"./research/components/header.js": [
		12770,
		9,
		5104,
		4931,
		8490,
		5837,
		3802,
		2770
	],
	"./research/components/members": [
		19720,
		9,
		5104,
		7850,
		4931,
		8490,
		2933,
		6064,
		1440,
		1763,
		6283,
		5837,
		3802,
		3555,
		9720
	],
	"./research/components/members.js": [
		19720,
		9,
		5104,
		7850,
		4931,
		8490,
		2933,
		6064,
		1440,
		1763,
		6283,
		5837,
		3802,
		3555,
		9720
	],
	"./research/components/publications": [
		52845,
		9,
		5104,
		4931,
		8490,
		1440,
		5837,
		3802,
		2845
	],
	"./research/components/publications.js": [
		52845,
		9,
		5104,
		4931,
		8490,
		1440,
		5837,
		3802,
		2845
	],
	"./research/components/research-areas": [
		84931,
		9,
		5104,
		7850,
		4931,
		8490,
		2933,
		1763,
		6283,
		5837,
		3802,
		3555,
		7395
	],
	"./research/components/research-areas.js": [
		84931,
		9,
		5104,
		7850,
		4931,
		8490,
		2933,
		1763,
		6283,
		5837,
		3802,
		3555,
		7395
	],
	"./research/components/section": [
		43802,
		9,
		4931,
		8490,
		5837,
		3802
	],
	"./research/components/section.js": [
		43802,
		9,
		4931,
		8490,
		5837,
		3802
	],
	"./research/components/tab-accordion-combo": [
		83555,
		9,
		5104,
		7850,
		2933,
		1763,
		6283,
		3555
	],
	"./research/components/tab-accordion-combo.js": [
		83555,
		9,
		5104,
		7850,
		2933,
		1763,
		6283,
		3555
	],
	"./research/research": [
		76750,
		9,
		5104,
		7850,
		570,
		4931,
		8490,
		6085,
		2933,
		6064,
		3136,
		1440,
		1763,
		6283,
		5837,
		3802,
		3555,
		9720,
		2770,
		893,
		2845,
		7395,
		8998,
		8645,
		6750
	],
	"./research/research.js": [
		76750,
		9,
		5104,
		7850,
		570,
		4931,
		8490,
		6085,
		2933,
		6064,
		3136,
		1440,
		1763,
		6283,
		5837,
		3802,
		3555,
		9720,
		2770,
		893,
		2845,
		7395,
		8998,
		8645,
		6750
	],
	"./research/research.scss": [
		58645,
		9,
		8645
	],
	"./research/theme": [
		5837,
		9,
		4931,
		8490,
		5837
	],
	"./research/theme.js": [
		5837,
		9,
		4931,
		8490,
		5837
	],
	"./separatemap/map-api": [
		74470,
		9,
		908,
		4470
	],
	"./separatemap/map-api.js": [
		74470,
		9,
		908,
		4470
	],
	"./separatemap/map-context": [
		83993,
		9,
		908,
		1440,
		4470,
		5381,
		3993
	],
	"./separatemap/map-context.js": [
		83993,
		9,
		908,
		1440,
		4470,
		5381,
		3993
	],
	"./separatemap/search-box/filters/filters": [
		82932,
		9,
		2933,
		1463,
		13,
		4917,
		932,
		1804,
		2932
	],
	"./separatemap/search-box/filters/filters.js": [
		82932,
		9,
		2933,
		1463,
		13,
		4917,
		932,
		1804,
		2932
	],
	"./separatemap/search-box/filters/filters.scss": [
		21804,
		9,
		1804
	],
	"./separatemap/search-box/inputs/inputs": [
		57402,
		9,
		5104,
		5397,
		7402
	],
	"./separatemap/search-box/inputs/inputs.js": [
		57402,
		9,
		5104,
		5397,
		7402
	],
	"./separatemap/search-box/inputs/inputs.scss": [
		25397,
		9,
		5397
	],
	"./separatemap/search-box/result-box/result-box": [
		82604,
		9,
		5104,
		6252,
		2604
	],
	"./separatemap/search-box/result-box/result-box.js": [
		82604,
		9,
		5104,
		6252,
		2604
	],
	"./separatemap/search-box/result-box/result-box.scss": [
		56252,
		9,
		6252
	],
	"./separatemap/search-box/results": [
		33364,
		9,
		5381,
		3364
	],
	"./separatemap/search-box/results.js": [
		33364,
		9,
		5381,
		3364
	],
	"./separatemap/search-box/search-box": [
		67112,
		9,
		5104,
		908,
		2933,
		1440,
		1463,
		13,
		4917,
		932,
		5397,
		4470,
		6252,
		5381,
		1804,
		7402,
		2604,
		2932,
		1067,
		3993,
		3364,
		7112
	],
	"./separatemap/search-box/search-box.js": [
		67112,
		9,
		5104,
		908,
		2933,
		1440,
		1463,
		13,
		4917,
		932,
		5397,
		4470,
		6252,
		5381,
		1804,
		7402,
		2604,
		2932,
		1067,
		3993,
		3364,
		7112
	],
	"./separatemap/search-box/search-box.scss": [
		61067,
		9,
		1067
	],
	"./separatemap/separatemap": [
		21087,
		9,
		5104,
		908,
		2933,
		8065,
		1440,
		1463,
		13,
		4917,
		932,
		5397,
		4470,
		6252,
		5381,
		1804,
		7402,
		2604,
		2932,
		1067,
		3993,
		3364,
		3551,
		7112,
		1087
	],
	"./separatemap/separatemap.js": [
		21087,
		9,
		5104,
		908,
		2933,
		8065,
		1440,
		1463,
		13,
		4917,
		932,
		5397,
		4470,
		6252,
		5381,
		1804,
		7402,
		2604,
		2932,
		1067,
		3993,
		3364,
		3551,
		7112,
		1087
	],
	"./separatemap/separatemap.scss": [
		13551,
		9,
		3551
	],
	"./subjects/new/about-openstax": [
		69652,
		9,
		6085,
		9819,
		9502,
		9652
	],
	"./subjects/new/about-openstax.js": [
		69652,
		9,
		6085,
		9819,
		9502,
		9652
	],
	"./subjects/new/about-openstax.scss": [
		89502,
		9,
		9502
	],
	"./subjects/new/context": [
		89819,
		9,
		6085,
		9819
	],
	"./subjects/new/context.js": [
		89819,
		9,
		6085,
		9819
	],
	"./subjects/new/hero": [
		63487,
		9,
		6085,
		6324,
		9819,
		2705,
		3487
	],
	"./subjects/new/hero.js": [
		63487,
		9,
		6085,
		6324,
		9819,
		2705,
		3487
	],
	"./subjects/new/hero.scss": [
		42705,
		9,
		2705
	],
	"./subjects/new/info-boxes": [
		23299,
		9,
		6085,
		9819,
		586,
		9064,
		3299
	],
	"./subjects/new/info-boxes.js": [
		23299,
		9,
		6085,
		9819,
		586,
		9064,
		3299
	],
	"./subjects/new/info-boxes.scss": [
		62289,
		9,
		9064
	],
	"./subjects/new/language-selector-section": [
		73215,
		9,
		5104,
		8950,
		7057,
		3215
	],
	"./subjects/new/language-selector-section.js": [
		73215,
		9,
		5104,
		8950,
		7057,
		3215
	],
	"./subjects/new/philanthropic-support": [
		86927,
		9,
		6085,
		9819,
		586,
		1637,
		6927
	],
	"./subjects/new/philanthropic-support.js": [
		86927,
		9,
		6085,
		9819,
		586,
		1637,
		6927
	],
	"./subjects/new/philanthropic-support.scss": [
		1637,
		9,
		1637
	],
	"./subjects/new/specific/blog-posts": [
		94990,
		9,
		5104,
		6085,
		6524,
		759,
		516,
		7609,
		2042,
		8561,
		4990
	],
	"./subjects/new/specific/blog-posts.js": [
		94990,
		9,
		5104,
		6085,
		6524,
		759,
		516,
		7609,
		2042,
		8561,
		4990
	],
	"./subjects/new/specific/blog-posts.scss": [
		48561,
		9,
		8561
	],
	"./subjects/new/specific/book-viewer": [
		83347,
		9,
		5104,
		8950,
		6085,
		2933,
		6064,
		1440,
		3794,
		9923,
		3394,
		6838,
		8376,
		8989,
		3493,
		1133,
		8085,
		9276,
		1430,
		5672,
		7051,
		516,
		6922,
		3883,
		4430,
		3347
	],
	"./subjects/new/specific/book-viewer.js": [
		83347,
		9,
		5104,
		8950,
		6085,
		2933,
		6064,
		1440,
		3794,
		9923,
		3394,
		6838,
		8376,
		8989,
		3493,
		1133,
		8085,
		9276,
		1430,
		5672,
		7051,
		516,
		6922,
		3883,
		4430,
		3347
	],
	"./subjects/new/specific/book-viewer.scss": [
		88786,
		9,
		4430
	],
	"./subjects/new/specific/components/carousel-section": [
		92042,
		9,
		5104,
		6524,
		759,
		7609,
		2042
	],
	"./subjects/new/specific/components/carousel-section.js": [
		92042,
		9,
		5104,
		6524,
		759,
		7609,
		2042
	],
	"./subjects/new/specific/components/carousel-section.scss": [
		67609,
		9,
		7609
	],
	"./subjects/new/specific/context": [
		90516,
		9,
		6085,
		516
	],
	"./subjects/new/specific/context.js": [
		90516,
		9,
		6085,
		516
	],
	"./subjects/new/specific/learn-more": [
		78655,
		9,
		5104,
		7850,
		6085,
		1763,
		516,
		4330,
		8655
	],
	"./subjects/new/specific/learn-more.js": [
		78655,
		9,
		5104,
		7850,
		6085,
		1763,
		516,
		4330,
		8655
	],
	"./subjects/new/specific/learn-more.scss": [
		74330,
		9,
		4330
	],
	"./subjects/new/specific/navigator": [
		81424,
		9,
		5104,
		8950,
		7850,
		6085,
		2933,
		6524,
		1463,
		1763,
		516,
		2882,
		4759,
		1424
	],
	"./subjects/new/specific/navigator-context": [
		84759,
		9,
		6524,
		4759
	],
	"./subjects/new/specific/navigator-context.js": [
		84759,
		9,
		6524,
		4759
	],
	"./subjects/new/specific/navigator.js": [
		81424,
		9,
		5104,
		8950,
		7850,
		6085,
		2933,
		6524,
		1463,
		1763,
		516,
		2882,
		4759,
		1424
	],
	"./subjects/new/specific/navigator.scss": [
		52882,
		9,
		2882
	],
	"./subjects/new/specific/specific": [
		72791,
		9,
		5104,
		8950,
		7850,
		570,
		6085,
		2933,
		6524,
		6064,
		1440,
		1463,
		1763,
		759,
		3794,
		9923,
		3394,
		6838,
		8376,
		8989,
		3493,
		1133,
		8085,
		9276,
		1430,
		5672,
		9819,
		586,
		7051,
		516,
		6922,
		2791
	],
	"./subjects/new/specific/specific.js": [
		72791,
		9,
		5104,
		8950,
		7850,
		570,
		6085,
		2933,
		6524,
		6064,
		1440,
		1463,
		1763,
		759,
		3794,
		9923,
		3394,
		6838,
		8376,
		8989,
		3493,
		1133,
		8085,
		9276,
		1430,
		5672,
		9819,
		586,
		7051,
		516,
		6922,
		2791
	],
	"./subjects/new/specific/specific.scss": [
		30987,
		9,
		987
	],
	"./subjects/new/specific/subject-intro": [
		5954,
		9,
		5104,
		8950,
		7850,
		6085,
		2933,
		6524,
		1463,
		1763,
		516,
		2882,
		4759,
		1424,
		3338,
		5954
	],
	"./subjects/new/specific/subject-intro.js": [
		5954,
		9,
		5104,
		8950,
		7850,
		6085,
		2933,
		6524,
		1463,
		1763,
		516,
		2882,
		4759,
		1424,
		3338,
		5954
	],
	"./subjects/new/specific/subject-intro.scss": [
		23338,
		9,
		3338
	],
	"./subjects/new/specific/translation-selector": [
		93616,
		9,
		5104,
		8950,
		7057,
		3616
	],
	"./subjects/new/specific/translation-selector.js": [
		93616,
		9,
		5104,
		8950,
		7057,
		3616
	],
	"./subjects/new/specific/webinars": [
		89768,
		9,
		5104,
		6085,
		6524,
		759,
		516,
		7609,
		2042,
		8706,
		9768
	],
	"./subjects/new/specific/webinars.js": [
		89768,
		9,
		5104,
		6085,
		6524,
		759,
		516,
		7609,
		2042,
		8706,
		9768
	],
	"./subjects/new/specific/webinars.scss": [
		48706,
		9,
		8706
	],
	"./subjects/new/subjects": [
		76584,
		9,
		5104,
		8950,
		7850,
		570,
		6085,
		2933,
		6524,
		6064,
		1440,
		1463,
		1763,
		759,
		6324,
		3794,
		9923,
		3394,
		6838,
		8376,
		8989,
		3493,
		1133,
		8085,
		9276,
		1430,
		5672,
		9819,
		586,
		7051,
		516,
		2791,
		4172
	],
	"./subjects/new/subjects-listing": [
		95981,
		9,
		5104,
		6085,
		9819,
		9113,
		5981
	],
	"./subjects/new/subjects-listing.js": [
		95981,
		9,
		5104,
		6085,
		9819,
		9113,
		5981
	],
	"./subjects/new/subjects-listing.scss": [
		99113,
		9,
		9113
	],
	"./subjects/new/subjects.js": [
		76584,
		9,
		5104,
		8950,
		7850,
		570,
		6085,
		2933,
		6524,
		6064,
		1440,
		1463,
		1763,
		759,
		6324,
		3794,
		9923,
		3394,
		6838,
		8376,
		8989,
		3493,
		1133,
		8085,
		9276,
		1430,
		5672,
		9819,
		586,
		7051,
		516,
		2791,
		4172
	],
	"./subjects/new/subjects.scss": [
		89033,
		9,
		9033
	],
	"./subjects/new/tutor-ad": [
		23508,
		9,
		6085,
		9819,
		6839,
		3508
	],
	"./subjects/new/tutor-ad.js": [
		23508,
		9,
		6085,
		9819,
		6839,
		3508
	],
	"./subjects/new/tutor-ad.scss": [
		66839,
		9,
		6839
	],
	"./subjects/new/use-categorized-books": [
		92807,
		9,
		6085,
		9819,
		2807
	],
	"./subjects/new/use-categorized-books.js": [
		92807,
		9,
		6085,
		9819,
		2807
	],
	"./subjects/old/book-viewer/book": [
		73636,
		9,
		5104,
		570,
		3883,
		3636
	],
	"./subjects/old/book-viewer/book-viewer": [
		24683,
		9,
		5104,
		570,
		6085,
		3883,
		3636,
		9427,
		4683
	],
	"./subjects/old/book-viewer/book-viewer.js": [
		24683,
		9,
		5104,
		570,
		6085,
		3883,
		3636,
		9427,
		4683
	],
	"./subjects/old/book-viewer/book.js": [
		73636,
		9,
		5104,
		570,
		3883,
		3636
	],
	"./subjects/old/context": [
		49427,
		9,
		6085,
		9427
	],
	"./subjects/old/context.js": [
		49427,
		9,
		6085,
		9427
	],
	"./subjects/old/subjects": [
		43733,
		9,
		5104,
		8950,
		570,
		6085,
		586,
		7057,
		3883,
		3636,
		9427,
		3552,
		4683,
		1502,
		3733
	],
	"./subjects/old/subjects.js": [
		43733,
		9,
		5104,
		8950,
		570,
		6085,
		586,
		7057,
		3883,
		3636,
		9427,
		3552,
		4683,
		1502,
		3733
	],
	"./subjects/old/subjects.scss": [
		23552,
		9,
		3552
	],
	"./subjects/subjects": [
		86530,
		9,
		6530
	],
	"./subjects/subjects.js": [
		86530,
		9,
		6530
	],
	"./team/people-tab/people-tab": [
		71813,
		9,
		8583,
		1813
	],
	"./team/people-tab/people-tab.js": [
		71813,
		9,
		8583,
		1813
	],
	"./team/people-tab/people-tab.scss": [
		48583,
		9,
		8583
	],
	"./team/team": [
		88587,
		9,
		5104,
		7850,
		6085,
		2933,
		6524,
		3136,
		1763,
		6324,
		6283,
		5074,
		8583,
		4336,
		1813,
		8587
	],
	"./team/team.js": [
		88587,
		9,
		5104,
		7850,
		6085,
		2933,
		6524,
		3136,
		1763,
		6324,
		6283,
		5074,
		8583,
		4336,
		1813,
		8587
	],
	"./team/team.scss": [
		34336,
		9,
		4336
	],
	"./webinars/webinar-list/webinar-list": [
		64138,
		9,
		5104,
		6781,
		4138
	],
	"./webinars/webinar-list/webinar-list.js": [
		64138,
		9,
		5104,
		6781,
		4138
	],
	"./webinars/webinar-list/webinar-list.scss": [
		56781,
		9,
		6781
	],
	"./webinars/webinars": [
		20928,
		9,
		5104,
		7850,
		6085,
		2933,
		3136,
		1763,
		6324,
		6283,
		6781,
		4138,
		2718,
		928
	],
	"./webinars/webinars.js": [
		20928,
		9,
		5104,
		7850,
		6085,
		2933,
		3136,
		1763,
		6324,
		6283,
		6781,
		4138,
		2718,
		928
	],
	"./webinars/webinars.scss": [
		72718,
		9,
		2718
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 19711;
module.exports = webpackAsyncContext;